import React from 'react';

export default class ItemInput extends React.Component {
  render(){
    return(
      <div className="box-input">
      <div className="box-input--title">{this.props.title}</div>
        <div className="box-input--border">
          <div className="box-input--inner">
            <input
              onChange={this.props.onChange}
              autoComplete="off"
              className="box-input--input"
              name={this.props.name}
              value={this.props.value}
              placeholder={this.props.placeholder} />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/classes/clientes/ItemInput.js